import DataTypeDto from "../datastructuremodule/DataTypeDto";
import TransformationCapabilitiesDto from "./TransformationCapabilitiesDto";
import TransformationOptionDto from "./TransformationOptionDto";

class TransformationOptionsDto extends TransformationCapabilitiesDto {
    Options: TransformationOptionDto[];

    constructor(
        logicId: number,
        label: string,
        icon: number,
        sourceDataType: DataTypeDto,
        targetDataType: DataTypeDto,
        transformationCapabilitiesType: string,
        options: TransformationOptionDto[]
    ) {
        super(logicId, label, icon, sourceDataType, targetDataType, transformationCapabilitiesType);
        this.Options = options;
    }
}

export default TransformationOptionsDto;
